import PropTypes from 'prop-types';
import React, { useContext, useRef } from 'react';
import ThemeContext from '../../../../providers/ThemeProvider';
import BookingCalendarCellBeginEnd from './BookingCalendarCellBeginEnd';

const BookingCalendarCellsBeginEnd = ({
  cells,
  onHoverDate,
  onHoverOffCells,
  onSelect,
  onMonthChange,
}) => {
  const theme = useContext(ThemeContext);
  const ref = useRef(null);

  const handleOnMouseLeave = () => {
    onHoverOffCells();
  };

  return (
    <>
      <div
        className="booking-calendar"
        onBlur={() => handleOnMouseLeave()}
        onMouseLeave={() => handleOnMouseLeave()}
        ref={ref}
      >
        <div className="booking-calendar__grid">
          {cells.map((cell, index) => (
            <BookingCalendarCellBeginEnd
              cell={cell}
              index={index}
              key={index}
              onHoverDate={onHoverDate}
              onMonthChange={onMonthChange}
              onSelect={onSelect}
            />
          ))}
        </div>
      </div>
      <style jsx>{`
        .booking-calendar {
          margin-bottom: 8px;
          position: relative;
        }
        .booking-calendar__grid {
          display: flex;
          flex-wrap: wrap;
          border: 1px solid ${theme.colors.primary};
        }
      `}</style>
    </>
  );
};

BookingCalendarCellsBeginEnd.propTypes = {
  cells: PropTypes.array,
  onHoverDate: PropTypes.func,
  onHoverOffCells: PropTypes.func,
  onMonthChange: PropTypes.func,
  onSelect: PropTypes.func,
};

BookingCalendarCellsBeginEnd.defaultProps = {
  cells: [],
  onHoverDate: () => false,
  onHoverOffCells: () => false,
  onMonthChange: () => false,
  onSelect: () => false,
};

export default BookingCalendarCellsBeginEnd;
